<template>

  <div class="container">

      <div class="row pt-5 ">

        <div class="col h-100 my-auto pt-5 ">

        <h4 v-if="!error" class="font-weight-light text-center pt-5 my-auto">Loading...</h4>
        <div v-else>
          <h4 class="font-weight-light text-center pt-5 my-auto">Sorry something went wrong!</h4>
          <p class="font-weight-light text-center mt-3">Please try again.</p>
        </div>

        </div>
      </div>
      
      
  </div>

</template>

<script>

export default {
  name: 'Auth',
  data() {
    return  {
      error: null
    }
  },
  methods: {
    loadData () {
      let token = this.$route.query.jwt;
      let payment_to = this.$route.query.payment_to;
      //let payment_model = this.$route.query.payment_model;


      if (token && payment_to) {

        localStorage.setItem('accessToken', token)
        this.$store.dispatch('storeToken', token)
        this.$store.dispatch('storePaymentTo', payment_to)
        //this.$store.dispatch('storePaymentModel', payment_model)
        this.$router.replace('/')

      } else {
        this.error = true;
      }

    }
  },
  beforeMount(){
      this.loadData()
   },
}
</script>

<style scoped>
html,
body {
  height: 100%
}
</style>